<template>
  <div class="header">
    <div class="left">
      <img src="../assets/logo.png" height="60px" style="margin-left: 20px" alt="Logo" />
      <span class="title">Adore参数管理</span>
      <span>V 1.0</span>
    </div>
    <div class="right">
      <div style="color: aqua">
        欢迎
        <span style="font-weight: 900; font-family: 'KaiTi'; color: red; font-size: 20px">{{getUsername}}</span>登录
      </div>
      <!-- <el-avatar size="large" src="https://empty" @error="errorHandler">
        <img src="../assets/load-fail.png" />
      </el-avatar> -->
      <el-dropdown size="small" @command="handleCommand" split-button>
        系统菜单
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="personal">个人中心</el-dropdown-item>
          <el-dropdown-item command="logout" divided>退出系统</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Header',
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters(['getUsername'])
  },
  methods: {
    errorHandler () {
      return true
    },
    handleCommand (command) {
      if (command === 'logout') {
        this.$confirm('是否退出系统?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.info('退出系统')
          // this.axios.get('http://localhost:8091/user/logout', {
          //   params: {
          //     token: this.$store.state.loginUser.token
          //   }
          // }).then(res => {
          //   this.$store.commit('logout')
          //   this.$router.push({ path: '/login' })
          // })
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.header {
  height: 100%;
  background: url(../assets/header-background.png) no-repeat;
  background-color: rgba(0, 0, 0, 0.3);
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left {
  width: 480px;
  color: aqua;
  display: flex;
  align-items: center;
}
.right {
  margin-right: 50px;
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  margin-left: 20px;
  color: aqua;
  font-weight: 900;
  font-family: 'KaiTi', Georgia, Serif;
  font-size: 35px;
}
</style>
